import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { FormDivider, FormParagraph, HeaderDivider } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProcedureThumbnails } from '../../utils/v1/ProcedureThumbnails';

export function GtoV1ProcedureSummary(props: ICustomControlProcedureReadProps) {
    return (
        <>
            {(props.procedure.assets.length > 0 || props.procedure.customControlData.files?.length > 0) && (
                <>
                    <ProcedureThumbnails {...props} />
                    <FormDivider />
                </>
            )}

            <HeaderDivider text="Anamnese" />

            <HorizontalFormGroupRead>
                <FormLabel>Wat zijn je klachten?</FormLabel>
                <InputContainer>
                    <FormParagraph bold>{props.procedure.customControlData.complaints}</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>
        </>
    );
}
